export const CONFIRM_PATCH_KB_CREDENTIALS = 'CONFIRM_PATCH_KB_CREDENTIALS';

export const confirmPatchKBCredentials = () => ({
  type: CONFIRM_PATCH_KB_CREDENTIALS,
});
